import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Asegúrate de importar BrowserRouter
import { CartProvider } from './context/CartContext'; // Importar el proveedor del carrito
import './styles/global.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <CartProvider>
            <App />
        </CartProvider>
    </BrowserRouter>
);

// Registra el Service Worker que muestra las notificaciones push de las
// alertas de precio (ver public/sw.js y src/lib/pushNotifications.js).
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch((error) => {
            console.error('No se pudo registrar el service worker:', error);
        });
    });
}
